import { Injectable, signal } from '@angular/core';

export interface SelectedHelper { id: number; name: string; }

const STORAGE_KEY = 'afs.helper';

@Injectable({ providedIn: 'root' })
export class HelperContextService {
  /** The picked helper, persisted across reloads until switched. */
  readonly helper = signal<SelectedHelper | null>(this.load());

  setHelper(h: SelectedHelper): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(h));
    this.helper.set(h);
  }

  clear(): void {
    localStorage.removeItem(STORAGE_KEY);
    this.helper.set(null);
  }

  private load(): SelectedHelper | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as SelectedHelper) : null;
    } catch {
      return null;
    }
  }
}
